module.exports = __webpack_public_path__ + "static/media/logooo1.dd8e846d.png";